import { InjectionToken } from '@angular/core';

export const SETTINGS = new InjectionToken<any>('SETTINGS');
export const WINDOW = new InjectionToken('WINDOW');
export const AWS_AMPLIFY = new InjectionToken('AWS_AMPLIFY');
export const AWS_AMPLIFY_AUTH = new InjectionToken('AWS_AMPLIFY_AUTH');

export enum Environment {
    Development = 1,
    Staging = 2,
    Production = 3,
    Uat = 4
}

export interface ISettings {
    currentSha?: string;
    applicationName: string;
    bugsnagApiKey?: string;
    cloudinaryApiKey?: string;
    cognitoUserPoolId?: string;
    cognitoClientId?: string;
    disableLoginPage?: boolean;
    environment: Environment;
    fabBlacklistedRoutePatterns?: (string | RegExp)[];
    unauthorizedInterceptorBlacklist?: string[];
    fileUploadUrl?: string;
    googleAnalyticsId?: string;
    googlePlacesSearchRadius?: number;
    helpUrl?: string;
    idleModalLifespanInSeconds?: number;
    idleTimerInSeconds?: number;
    imageUploadUrl?: string;
    internalGoogleAnalyticsId?: string;
    isDemo: boolean;
    isInternalApp?: boolean;
    isManagement: boolean;
    launchDarklyId?: string;
    managementHome?: string;
    pageNotFoundButtonText?: string;
    production: boolean; // This is a default from angular.
    spinnerType?: string;
    maximumImageDownloadSize?: number;
    warningImageDownloadSize?: number;
    downloadBackgroundTimeout?: number; // This is the timeout for when a download starts running in the background rather than making the user wait.
    useWebSockets?: boolean;
    healthCheckTimeoutMs?: number;
    notificationPollingTimerInSeconds?: number;
    httpApiDefaultServiceName?: string;
    httpApiServiceNameUrlMap?: { [key: string]: string };
}
